/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterInteractionIdKind = (typeof FilterInteractionIdKind)[keyof typeof FilterInteractionIdKind];

export const FilterInteractionIdKind = {
  interaction_id: 'interaction_id',
} as const;
